import styled from '@emotion/styled';
import { MenuSectionItem, Typography } from '@kc-console/common-ui';
import { useScopedLinkBuilder } from '@kc-console/context';
import { useTranslation } from '@kc-console/core';
import { SpriteSvgIcon } from '@kc-console/shared-ui';

import { useRefinedPopularServiceState } from '../../../../hooks';
import { useSearchPopover } from './SearchPopoverProvider';

const MAX_DISPLAY_COUNT = 5;

const PopularServices = () => {
  const { t } = useTranslation();
  const { popularServices = [] } = useRefinedPopularServiceState();
  const { getProps } = useScopedLinkBuilder();
  const { closePopover } = useSearchPopover();

  const displayedServices = (popularServices ?? []).slice(0, MAX_DISPLAY_COUNT);

  return (
    <MenuSectionItem title={t('layout:search.popular.title')} expanded>
      <PopularServiceListWrapper>
        {displayedServices.map(service => (
          <li key={service.keyword}>
            <ServiceLink {...getProps(service.path, { onClick: closePopover })}>
              <ServiceIconWrapper>
                <SpriteSvgIcon
                  id={service.keyword}
                  fontSize={40}
                  category={'BeyondServiceRegular'}
                />
              </ServiceIconWrapper>
              <ServiceName variant={'label/regular/2xs'}>{service.name}</ServiceName>
            </ServiceLink>
          </li>
        ))}
      </PopularServiceListWrapper>
    </MenuSectionItem>
  );
};

const PopularServiceListWrapper = styled.ul`
  display: flex;
  gap: 12px;
  padding: 6px 16px;
`;

const ServiceLink = styled('a')`
  display: flex;
  flex-direction: column;
  width: 64px;
  gap: 4px;
  color: #222;
  text-decoration: none;
  &:focus-visible {
    outline: none;
  }
`;

const ServiceIconWrapper = styled.div`
  width: 64px;
  height: 64px;
  padding: 12px;
  background-color: #f6f7f9;
  position: relative;

  ${({ theme }) =>
    theme.mixins.focusRing('inside', {
      selectors: {
        focus: 'a:focus-visible > &',
      },
    })}
`;

const ServiceName = styled(Typography)`
  text-align: center;
`;

export default PopularServices;
